export default "__VITE_ASSET__CC_FSoPh__"